import CbuPaymentsApi from './CbuPaymentsApi';
export default CbuPaymentsApi;
